export enum TagSort {
    prod = 1,
    stage = 2,
    dev = 3,
    old = 4,
    other = 5
}
